<template>
  <div :class="`z-message-notice ${activeClass}`">
    <div class="z-message-notice-content">
      <i :class="icon" />
      <span>{{ content }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZMessageNotice',
  props: {
    type: {
      type: String,
      default: 'info'
    },
    duration: {
      type: Number,
      default: 1500
    },
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeClass: ''
    }
  },
  computed: {
    icon() {
      const { type } = this

      return type === 'loading'
        ? 'icon-loading load-loop'
        : type === 'info'
        ? 'icon-info-filled'
        : type === 'warn'
        ? 'icon-warn-filled'
        : type === 'success'
        ? 'icon-check-filled'
        : type === 'error'
        ? 'icon-close-filled'
        : ''
    },
    isSupport() {
      return 'TransitionEvent' in window
    }
  },
  methods: {
    open() {
      this.activeClass = this.isSupport ? 'move-up-enter-active' : 'z-message-notice-enter'
    },
    close() {
      this.activeClass = this.isSupport ? 'move-up-leave-active' : 'z-message-notice-leave'
    }
  }
}
</script>

<style lang="postcss">
.z-message-notice {
  padding: 8px;
  text-align: center;
  transition: height 0.3s ease-in-out, padding 0.3s ease-in-out;

  &.z-message-notice-enter {
    option: 1;
  }

  &.z-message-notice-leave {
    option: 0;
  }

  .z-message-notice-content {
    display: inline-block;
    pointer-events: all;
    padding: 8px 16px;
    border-radius: 4px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
    background: #fff;
    position: relative;

    i,
    span {
      vertical-align: middle;
    }

    i {
      margin-right: 4px;
    }

    .icon-info-filled {
      color: #2db7f5;
    }

    .icon-warn-filled {
      color: #ff9900;
    }

    .icon-check-filled {
      color: #19be6b;
    }

    .icon-close-filled {
      color: #ed4014;
    }

    .icon-loading {
      color: #2d8cf0;
    }
  }
}
</style>
